import React from 'react';
import { observer } from 'mobx-react';

import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { constants } from '../../../config';
import { routeNaming, AppLink } from '../../../routes';
import styles from './BrandService.css';
import { SEO } from '../../../common/seo';

const serviceGoogleMapsLinks = {
  akitaService: 'https://goo.gl/maps/VZG27Cs3LVR2',
  bronxService: 'https://goo.gl/maps/CFeZ2vKujNS2',
  goldexService: 'https://goo.gl/maps/nTJovLQNR7t',
  jamesService: 'https://goo.gl/maps/5Yyfbqa2YUP2',
  kasselService: 'https://goo.gl/maps/YUtUvZpoocF2',
  rydesulService: 'https://goo.gl/maps/MAKzGzCQaKR2',
  solerYPalauService: 'https://goo.gl/maps/MPxvUggEw8J2',
};

const BrandService = observer(() => {
  const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
  return (
    <div className={styles.container}>
      <SEO
        title="Servicio Bronx"
        description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainWrapper}>
        <div className={styles.mainContent}>
          {showMobileVersion ?
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.INFORMATION_MENU_MOBILE}
              >
                Información
              </AppLink>
              <span> &gt; Servicio Bronx </span>
            </p>
            : <InformationMenu indexSelectedItem={7} />}
          <div className={styles.bodyContainer}>
            {/* <div className={styles.titleContainer}>
              <h1 className={styles.mainTitle}> Servicio Bronx</h1>
            </div> */}
            <div className={styles.contentSection}>
              <h2 className={styles.contentSectionTitle}> BRONX </h2>
              <p>
                Cocinas, Refrigeradores, Secarropas, Estufas, Bordeadoras, Cortadoras y
                Ventiladores se atienden en:
                <br />
                <b>Constitución 1981</b>, entre Miguelete y Nicaragua.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.bronxService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p> Tel.: 2400 0400* </p>
              <p> E-mail: info@rydesul.com </p>
              <p>
                Web:
                &nbsp;
                <a
                  className={styles.webLink}
                  href="http://www.rydesul.com"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  www.rydesul.com
                </a>
              </p>
              <p>Horario continuo de lunes a viernes de 9 a 18.00 hs y sábados de 9 a 13.00 hs.</p>
              <p>
                Calefones se atienden en:
                <br />
                <b>Samuel Blixen 4661</b> entre Caldas y Santana.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.rydesulService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
                <br />
                Tel.: 2619 4240
                <br />
                WhatsApp: 098059813
                <br />
                Horario continuo de lunes a viernes de 8.30 a 16.30 hs.
              </p>
              <br />
              {/* <h2 className={styles.contentSectionTitle}> JAMES </h2> */}
              {/* <p>
                <b>Fraternidad 3948</b>, entre Luis José de la Peña
                y Dr. Vázquez Sagastume.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.jamesService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p>Tel.: 2309 6066*</p>
              <p>E-mail: service@james.com.uy</p>
              <p> Horario continuo de lunes a viernes de 8 a 17 hs. </p>
              <br />
              <h2 className={styles.contentSectionTitle}> GOLDEX </h2>
              <p>
                <b>Río Negro 1617</b>, entre Galicia y Cerro Largo.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.goldexService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p>Tel.: 2902 2606</p>
              <p>Horario: lunes a viernes de 9 a 13 hs. y de 14 a 18 hs.</p>
              <br />
              <h2 className={styles.contentSectionTitle}> KASSEL </h2>
              <p>
                <b>Mendoza 2610</b>, esquina San Fructuoso.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.kasselService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p>Tel.: 2200 1010</p>
              <p>Horario continuo de lunes a viernes de 9 a 18 hs.</p>
              <br />
              <h2 className={styles.contentSectionTitle}> AKITA </h2>
              <p>
                <b>Hocquart 1677</b>, entre República y Arenal Grande.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.akitaService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p>Tel.: 2924 8613</p>
              <p>Horario: lunes a viernes de 9 a 13 hs. y de 14 a 19 hs.</p>
              <br />
              <h2 className={styles.contentSectionTitle}> SOLER Y PALAU </h2>
              <p>
                <b>Gral. Flores 2425</b>, entre República y Arenal Grande.
                &nbsp;
                <a
                  className={styles.mapLink}
                  href={serviceGoogleMapsLinks.solerYPalauService}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  (Ver mapa)
                </a>
              </p>
              <p>Tel.: 2204 2588</p>
              <p>Horario: lunes a viernes de 9 a 12:30 hs. y de 13:30 a 18 hs.</p> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
});

export { BrandService };



// WEBPACK FOOTER //
// ./src/pages/information/brand-service/BrandService.jsx